import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=6e7aec9f&"
import script from "./DepartmentList.vue?vue&type=script&lang=js&"
export * from "./DepartmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports